const APP_SETTINGS = {
  jobTitleIncludedCustomFields: [
    {label: "Bidder"},
    {label: "WorkCode"},
  ],
  jobQueueDay: "Sunday",
  weatherPostalCode: "99201"
};

export default APP_SETTINGS;